<template>
	<div class="c-brands-slug-ad-list" v-if="isAuth" @scroll="onScroll">
		<AdList v-if="init" ref="multi" :adIds="adIds" @onSave="onSave"></AdList>
	</div>
</template>

<script>
import AdList from '@swipekit/components/brand-slug/ad-list';
import api from '@swipekit/lib/api';

export default {
	components: {
		AdList,
	},

	data: function () {
		return {
			adIds: [],
			init: false,
		};
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
		standalone: function () {
			return this.$store.getters['standalone'];
		},
	},

	methods: {
		onSave: function (e) {
			const blockId = e.blockId;

			this.$store.dispatch('boards/refreshAll');

			this.adIds.push(blockId);
		},
		onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
			let buffer = 200;
			if (scrollTop + clientHeight >= scrollHeight - buffer) {
				this.$refs.multi.onEnd();
			} else {
			}
		},
		async getIds() {
			let ids = await api.ads.getAdIds().catch((err) => {
				console.log(err);
			});

			this.adIds = ids;

			this.init = true;
		},
	},

	mounted: function () {
		this.getIds();
	},
};
</script>

<style lang="scss">
.c-brands-slug-ad-list {
}
</style>
